import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import {  Link } from "react-router-dom";
import base_URL from "../../base_URL";
import axios from "axios";
import "../Navbar/NavBar.css";

class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      theme: [],
      clicked: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.renderMyData = this.renderMyData.bind(this);
  }

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };

  renderMyData = async () => {
    await axios.get(`${base_URL}/theme/all`, {}).then((response) => {
      this.setState({
        theme: response.data,
      });
    });
  };
  componentDidMount() {
    this.renderMyData();
  }

  render() {
    if (localStorage.getItem("Admin1token") == null)
      return <Redirect to="/login" />;

   
    return (
      <div>
        <nav className="NavBarItems">
        <img width="120px" height="80px" src="logo3.png"/>
         
          <h1 className="navbar-logo">
          Relocator
          </h1>
          
          <div className="menu-icon" onClick={this.handleClick}>
            {
              <i
                className={this.state.clicked ? "fa fa-times" : "fa fa-bars"}
              ></i>
            }
          </div>
          <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}>
            <li onClick={this.handleClick}>
              <Link className="nav-links" to="/admin/AllUsers">
                Users
              </Link>
            </li>
            <li onClick={this.handleClick}>
              <Link className="nav-links" to="/admin">
                DashBoard
              </Link>
            </li>
            <li onClick={this.handleClick}>
              <Link className="nav-links" to="/admin/AllService">
                Services
              </Link>
            </li>
            <li onClick={this.handleClick}>
              <Link className="nav-links" to="/admin/AllTheme">
                Themes
              </Link>
            </li>
            <li onClick={this.handleClick}>
              <Link className="nav-links" to="/admin/need">
                Needed Theme
              </Link>
            </li>
            <li onClick={this.handleClick}>
              <Link className="btn btn-danger nav-links" to="/admin/logout">
                Logout
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default Admin;
